import { Fragment } from "react";

import { formatOrderNumber } from "../../OrdersList/order-list-utils";
import { badgeForStatus } from "../../../../../features/orders/orderStatus";
import SummaryFooter from "./SummaryFooterButtons";
import { orderReasonStatuses } from "../order-detail-utils";
// import ReviewCard from "./ReviewCard";
import SupplierReceipt from "../SupplierReceipt";

const OrderDetailSummary = ({ detail, cancellableIds, refetch }) => {
  const badge = badgeForStatus(detail.status);
  const refunded = detail.status === "REFUNDED";

  const showReason =
    orderReasonStatuses.includes(detail.status) && detail.statusChangeComment;

  return (
    <Fragment>
      <section className="ord-panel ord-panel-compact">
        <div className="ord-panel-head ord-order-head">
          <span className="ord-card-number">
            {formatOrderNumber(detail.orderNumber)}
          </span>

          <span className="ord-placed-at">
            {detail.placedDate} | {detail.placedTime}
          </span>

          {badge && (
            <span className={`ord-status ord-status-${badge.tone}`}>
              {badge.label}
            </span>
          )}
        </div>

        {showReason && (
          <p className={`ord-note${refunded ? " is-info" : ""}`}>
            <img
              src={`/assets/icons${
                refunded ? "/purple-alert.svg" : "/alert-icon.svg"
              }`}
              alt=""
              aria-hidden="true"
            />

            {detail.statusChangeComment}
          </p>
        )}
      </section>

      <SupplierReceipt detail={detail} supplier={detail.supplier}>
        <div className="ord-actions">
          <SummaryFooter
            cancellableIds={cancellableIds}
            statusGroup={detail.statusGroup}
            orderId={detail.id}
            refetch={refetch}
          />
        </div>
      </SupplierReceipt>

      {/* {detail.rated && <ReviewCard detail={detail} />} */}
    </Fragment>
  );
};

export default OrderDetailSummary;
